
export const getSubData = ({data, criterions}) => {
  
  const results = criterions.reduce((results, criterion) => ({...results, [criterion.id]: {}}), {})

  data.forEach(value => {
    if (!results[value.group_id]) return
    const existValue = results[value.group_id][value.orgname] || 0
    const num = Number(String(value.raw_value).replace(',', '.'))
    const raw_value = !Number.isFinite(num) || num === -1 ? 0 : num
    results[value.group_id][value.orgname] = Math.round((existValue + raw_value) * 100) / 100
  });

  return results
}